import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@3plearning/react-components';
import css from './live-maths-level-picker.scss';
import liveMathsLevelPickerActions from './live-maths-level-picker-actions';

const NUM_LEVELS = 10;

/**
 * Component to pick the Live Maths level to show in the results table
 * Displays levels 1-10 with current selection highlighted, updates value in redux store when new level picked
 */
export class LiveMathsLevelPicker extends Component {
    static propTypes = {
        pickLevel: PropTypes.func,
        liveMathsLevel: PropTypes.number
    };

    constructor(props) {
        super(props);
        this.levels = Array(NUM_LEVELS).fill(null);
    }

    render() {
        const { pickLevel, liveMathsLevel } = this.props;

        return (
            <div className={css.component}>
                {this.levels.map((item, idx) => {
                    const level = idx + 1;
                    return (
                        <Button
                            key={level}
                            text={`${level}`}
                            className={`${css.level} ${
                                liveMathsLevel === level ? css.active : ''
                            }`}
                            onClick={() => pickLevel(level)}
                        />
                    );
                })}
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        liveMathsLevel: state.liveMathsLevel
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            pickLevel: liveMathsLevelPickerActions.pickLevel
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(LiveMathsLevelPicker));



// WEBPACK FOOTER //
// ./components/live-maths-level-picker/live-maths-level-picker.js